[{
        "coreStep": "Firm Order",
        "generalTask": "Client Discussion",
        "actionDetails": "<ul><li>Discuss and review quotes and proposed firm order terms with the Client including subjectivities, non-currencies and non-concurrent language.<\/li><li>Receive written Client instruction/acceptance of firm order, including acceptance or declination of non-concurrent provisions.<\/li><li>Send firm order terms to contract drafter, copy Ops Specialist<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "No",
        "guidanceReferenceLink": "<a href=\"https:\/\/ajg0.sharepoint.com\/sites\/gre-Gateway\/_layouts\/15\/download.aspx?UniqueId=fe24d972%2D0abc%2D4437%2Da00b%2De78f08e75de7\" target=\"_self\" rel=\"noopener\">Non-Concurrency Handling<\/a>"
    },
    {
        "coreStep": "Firm Order",
        "generalTask": "Create Firm Order Contract",
        "actionDetails": "<ul><li>Contract drafter updates contract draft to include firm order terms<\/li><li>Contract Drafter creates draft I&L's for any non-concurrent provisions<\/li><li>Send firm order contract to Broker Team, copying Ops Specialist and CSA<\/li><li>Send firm order contract and non-concurrent I&L's to Broker Team, copying Ops Specialist and CSA<\/li><\/ul>",
        "responsibility": "CD\/BT\/OS",
        "cemRequirement": "No",
        "guidanceReferenceLink": "<a href=\"https:\/\/ajg0.sharepoint.com\/sites\/gre-Gateway\/_layouts\/15\/download.aspx?UniqueId=fe24d972%2D0abc%2D4437%2Da00b%2De78f08e75de7\" target=\"_self\" rel=\"noopener\">Non-Concurrency Handling<\/a>"
    },
    {
        "coreStep": "Firm Order",
        "generalTask": "SPOE",
        "actionDetails": "<ul><li>Firm order contract draft and non-concurrent I&L's to be submitted for SPOE and approved by authorized SPOE prior to sending to the client<\/li><\/ul>",
        "responsibility": "BT\/CD",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": "<a href='https://ajg0.sharepoint.com/sites/gre-Gateway/_layouts/15/download.aspx?UniqueId=b2690527%2Deb94%2D4938%2D917c%2D548936b13995', target = \"_self\">GEM Authorized Second Pair of Eyes List<\/a>"
    },
    {
        "coreStep": "Firm Order",
        "generalTask": "FOT to Client",
        "actionDetails": "<ul><li>Send firm order term acknowledgement to client<\/li><li>Send firm order term contract and non-concurrent I&L's to Client, including the redline version, utilizing Template Text<\/li><li>Copy Contract Drafter and Ops Specialist in the transmittal email<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": "<a href=\"https:\/\/ajg0.sharepoint.com\/sites\/gre-Gateway\/_layouts\/15\/download.aspx?UniqueId=fe24d972%2D0abc%2D4437%2Da00b%2De78f08e75de7\" target=\"_self\" rel=\"noopener\">Non-Concurrency Handling<\/a>"
    },
    {
        "coreStep": "Firm Order",
        "generalTask": "Client Approval",
        "actionDetails": "<ul><li>Obtain Client's written approval of firm order contract including non-concurrent I&L's prior to sending to the markets<\/li><li>If FOT is fully subscribed at time of presentation, secure Client's approval to bind FOT and market subscriptions<\/li><\/ul><strong>Note: Any modifications to the FOT contract require repeating SPOE approvals and Client's approval of new versions<\/strong>",
        "responsibility": "BT\/CD\/OS",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Firm Order",
        "generalTask": "FOT to Markets",
        "actionDetails": "<ul><li> Send firm order terms and contract to markets. Include non-concurrent I&L's for applicable markets.<\/li><li>For London Markets include London wrapper and all London Markets I&L's - Follow SPOE requirement for London I&L's<\/li><\/ul>",
        "responsibility": "BT\/CD",
        "cemRequirement": "No, unless London markets – then Yes",
        "guidanceReferenceLink": ""
    }
]
